import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import Footer from "../components/Footer";
import "./TisanesPage.css";

const BASE = "https://storage.googleapis.com/rasai-nutrie-assets/products/tisanes";

const tisanes = [
  { id: "tisane-peppermint", name: "Peppermint Tisane", price: 25, image: `${BASE}/peppermint.png` },
  { id: "tisane-lemonmint",  name: "Lemonmint Tisane",  price: 24, image: `${BASE}/lemonmint.png` },
  { id: "tisane-lavender",   name: "Lavender Tisane",   price: 25, image: `${BASE}/lavender.png` },
  { id: "tisane-mint-basil", name: "Mint Basil Tisane", price: 24, image: `${BASE}/mint-basil.png` },
  { id: "tisane-lemongrass", name: "Lemongrass Tisane", price: 23, image: `${BASE}/lemongrass.png` },
  { id: "tisane-rose",       name: "Rose Tisane",       price: 24, image: `${BASE}/rose.png` },
  { id: "tisane-chamomile",  name: "Chamomile Tisane",  price: 26, image: `${BASE}/chamomile.png` },
  { id: "tisane-rosemary",   name: "Rosemary Tisane",   price: 26, image: `${BASE}/rosemary.png` },
];

const TisanesPage = () => (
  <div className="tisanes-page">
    <div className="tisanes-hero">
      <div className="tisanes-hero-overlay">
        <Link to="/products" className="tisanes-back">← All Categories</Link>
        <h1 className="tisanes-hero-title">TISANES</h1>
        <p className="tisanes-hero-sub">Nature's blend · Health &amp; Wellness · RASAI nutrie</p>
      </div>
    </div>

    <div className="tisanes-body">
      <div className="tisanes-grid">
        {tisanes.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>

    <Footer />
  </div>
);

export default TisanesPage;
